import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  data() {
    return {
      collectList: [],
      // 下拉品牌类型列表
      collectTypeOptionsList: [],
      // 分页配置项
      setCollectPage: {
        pageSize: 20, // 每页显示条数
        currentPage: 1, // 当前页
        total: 0, // 总条数
        totalPage: 1
      }
    }
  },
  created() {
  },
  methods: {
    initCollectList() {
      const data = {
        pageNo: this.setCollectPage.currentPage,
        pageSize: this.setCollectPage.pageSize
      }
      SmartVehicleInspection.getCollectList(data).then(res => {
        if (res.success) {
          const { records, total, size, pages } = res.result
          this.setCollectPage.pageSize = size;
          this.setCollectPage.total = total;
          this.setCollectPage.totalPage = pages;
          let arr = [];
          records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.account = value.account;
            obj.status = value.status;
            arr.push(obj);
          });
          this.collectList = arr;
          this.collectTypeOptionsList = this.collectTypeOptionsList.concat(arr)
        }
      })
    },

    // 给自定义指令用的方法
    handleCollectScrollDropdown() {
      this.setCollectPage.currentPage++
      // 这一步是做了一个容错判断 currentPage>totalPage 时 return出去
      if (this.setCollectPage.currentPage > this.setCollectPage.totalPage) return
      // 获取列表接口
      this.initCollectList()
    }
  }
}